module.exports = __webpack_public_path__ + "static/media/chevron-up.51983d02.svg";